export default [
  {
    path: '/templates',
    name: 'templates',
    component: () => import('@/views/chat/templates-whatsapp/TemplatesWhatsApp.vue'),
    meta: {
      pageTitle: 'Templates WhatsApp',
    },
  },
]
